<template lang="pug">
  .contact
    .contact__hearder
      .contact__hearder__back
        span(@click="$router.go(-1)")
          i.el-icon-arrow-left {{ $t('返回') }}
      img(
        @click="$router.push('/home')"
        src="@/assets/logo_blue.png"
      )
    .contact__content__container
      .title {{ $t('咨询合作') }}
      .contact__form
        el-form(
          v-model="data"
          ref="form"
          :model="data"
          label-width="400px"
          :rules="rules"
          label-position="top"
        )
          .form-row
            el-form-item(
              :label="$t('姓名')"
              prop="name"
            )
              el-input(
                v-model="data.name"
                :placeholder="$t('姓名')"
              )
            el-form-item(
              :label="$t('联系电话')"
              prop="phone"
            )
              el-input(
                :placeholder="$t('联系电话')"
                v-model="data.phone"
              )
          .form-row
            el-form-item(
              :label="$t('公司')"
            )
              el-input(
                v-model="data.company"
                :placeholder="$t('公司')"
              )
            el-form-item(
              :label="$t('邮箱')"
            )
              el-input(
                :placeholder="$t('邮箱')"
                v-model="data.email"
              )
          el-form-item(
            :label="$t('需求')"
          )
            el-input(
              style="width: 100%"
              v-model="data.remark"
              :placeholder="$t('您希望针对哪方面进行咨询或合作')"
            )
    el-button(
      @click="onSubmit"
    ) {{ $t('提 交') }}

</template>"

<script>
import Vue from 'vue'
import axios from 'axios'
import {Message} from "element-ui"
import { format4backend } from '@/util'
export default {
  data () {
    return {
      data: {
        name: '',
        phone: '',
        remark: '',
        company:'',
        email:''
      },
      rules: {
        name: [
          { required: true, message: this.$t('请输入姓名')}
        ],
        phone: [
          { required: true, message: this.$t('请输入联系电话') }
        ]
      }
    }
  },
  methods: {
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.onConfirm()
        }
      })
    },
    onConfirm () {
      let params = this.data
      params.from_url = this.$route.query.redirectUrl
      params.button_name = this.$route.query.buttonName
      params = {
        official_website_contact: params
      }
      axios.post('/cj/admin/saveOfficialContact', format4backend(params))
        .then(res => {
          if(res.code===1){
            this.$alert('提交成功！我们将尽快与您联系。', {
            confirmButtonText: '确认',
            callback: action => {
              Message({
                type: 'info',
                message: `action: ${action}`
              })
            }
          })
          }else{
            Message(res.msg)
          }
        })
    }
  }
}
</script>

<style lang="stylus">
.contact
  .contact__hearder
    height 74px
    border-bottom 1px solid rgba(151, 151, 151, 0.25)
    display flex
    align-items center
    justify-content center
    position relative
    img
      width 210px
    .contact__hearder__back
      position absolute
      top 0
      bottom 0
      left 32px
      text-align center
      span
        cursor pointer
        line-height 74px
        font-size 18px
        color #4e8fcc
  .title
    font-size 36px
    color $black-title
    text-align center
    margin 40px auto
  .contact__form
    display flex
    justify-content center
    align-items center
    width 824px
    margin auto
  .el-form
    .el-form-item__label
      font-size 18px !important
      color $black-title !important
      font-weight normal
    .el-form-item__content .el-input--mini
      font-size 18px !important
  .form-row
    display flex
    width 832px
    justify-content space-between
  .el-input
    height 48px
    width 400px
    input
      height 48px
      line-height 48px
  .el-button
    background: linear-gradient(90deg,#5394FC,#75caff)
    border-radius 24px
    font-size 18px
    width 346px
    height 48px
    display flex
    align-items center
    justify-content center
    margin auto
    border-color transparent
    color #ffffff
    margin-top 20px
    &:hover,&:focus
      color #ffffff
      background: linear-gradient(90deg,#4789c9,#75caff)
      border-color transparent
.el-message-box
  .el-message-box__btns
    .el-button
      width 50px !important
      padding 7px 10px !important
      height 32px
      border transparent
      color #ffffff
      &:hover,&:focus
        border-color transparent
        background #3370d2
</style>
